import React from 'react';
import { string, func } from 'prop-types';
import {
    FlexContainer,
    Row,
    SalesChannelByCompanySelect
} from '../../common';

const Filters = ({ currentValue, onChangeSalesChannels }) => (
    <FlexContainer padding={23}>
        <Row border='1px solid #eaeaea' borderRadius={3} padding='3px 13px' backgroundColor='white'>
            <SalesChannelByCompanySelect width={currentValue} onChangeSalesChannels={onChangeSalesChannels} />
        </Row>
    </FlexContainer>
);

Filters.propTypes = {
    currentValue: string,
    onChangeSalesChannels: func
};

export default Filters;
